import React, {useCallback, useEffect, useState} from "react";
import {
    AiFillCaretRight,
    AiFillEdit,
    AiOutlineHome,
    AiOutlineQuestionCircle,
    AiOutlineRotateLeft
} from 'react-icons/ai';
import {useViewerStore} from "../../../../store/store";
import {SetupObstUI, SetupTreeGroup} from "../Three-JS-Viewer/Controllers/TransControl";
import MoveModuleByMeasurement from "../Modal/Modal-Content/MoveModuleByMeasurement";
import {BiLocationPlus, BiMove, BiMoveHorizontal, BiRectangle} from "react-icons/bi";
import {RiBuildingFill, RiDeleteBin2Line, RiDeleteBinLine, RiLayout4Line, RiPaintFill} from "react-icons/ri";
import {MdContentCopy, MdOutlineClose, MdOutlineViewModule, MdRoofing} from "react-icons/md";
import {GiMoonOrbit} from "react-icons/gi";
import {FaTree} from "react-icons/fa";
import {IoBookmarkSharp} from "react-icons/io5";
import {TbBuildingBank, TbBuildingCommunity} from "react-icons/tb";
import {useCurrentUser} from "../../../../contexts/UserContext";
import {GetSelModules, setBuildingAsDetachedStructure, updateModuleCount} from "../Three-JS-Viewer/Controllers/ModuleControl";
import {CheckCircleIcon, SparkleIcon} from "@phosphor-icons/react";
import {deActivateRoof, ifRoofDeactivated, reActivateRoof, resolveTreeObstId} from "../Three-JS-Viewer/Controllers/Common";
import {clickButtonWithRef, setPathname} from "../../../../helpers/storeHelpers";
import { canvasContainerRef } from "../Three-JS-Viewer/canvasRef";
import {
    ModuleMesh,
    ObstructionMesh,
    RayCastIntersectedObjectType,
    RoofMesh, THREEJSGroupType,
    TreeGroup,
    VoidOrPromise
} from "../../../../@types/types";
import { EditAction, TreeProperty } from "../../../../@types/enums";
import {isGroundMount} from "../Three-JS-Viewer/Controllers/PlaneRoofControls";
import { canGhostTreeSelection } from "../Three-JS-Viewer/Controllers/EPCControl";


interface ContextSubMenuItem {
    title: string;
    key?: string;
    icon?: React.ReactNode;
    visible?: boolean;
    isDisabled?: boolean;
}

interface ContextMenuItem {
    title: string;
    key?: string;
    icon?: React.ReactNode;
    visible: boolean;
    submenu?: ContextSubMenuItem[];
    is_active?: boolean;
    specialClassName?: string;
}

interface ContextMenuTemplate {
    roof: ContextMenuItem[];
    obstruction: ContextMenuItem[];
    tree: ContextMenuItem[];
    modules: ContextMenuItem[];
    obstructionObjectContextMenu: ContextMenuItem[];
    roofObjectContextMenu: ContextMenuItem[];
    treeObjectContextMenu: ContextMenuItem[];
    moduleObjectContextMenu: ContextMenuItem[];
    pathwayObjectContextMenu: ContextMenuItem[];
    epcTouchContextMenu: ContextMenuItem[];
    epcContextMenu: ContextMenuItem[];
}

interface AnchorPoint {
    x: number;
    y: number;
}


const ContextMenu = () => {
    //Global Context
    const sceneViewer: any = useViewerStore(state => state.sceneViewer);
    const {user, hasCapability} = useCurrentUser();
    const pathname = useViewerStore((state) => state.pathname)


    //Global States
    const isPointerOnObject = useViewerStore.getState().isPointerOnObject
    const pointerDownSelectedObjectType = useViewerStore.getState().pointerDownSelectedObjectType
    const pointerDownSelectedObject : RayCastIntersectedObjectType = useViewerStore.getState().pointerDownSelectedObject
    const accessoryBuildingList = useViewerStore.getState().accessoryBuildingList;
    const treeCartItems = useViewerStore.getState().treeCartItems;
    const refreshContextMenu = useViewerStore(state => state.refreshContextMenu)

    //For Undo-redo actions
    const selectedTrees = useViewerStore(state => state.selectedTrees);
    const selectedObstruction = useViewerStore((state) => state.selectedObstruction);


    //Local States
    const [anchorPoint, setAnchorPoint] = useState({x: 0, y: 0});
    const [showMenu, setShowMenu] = useState(false);
    const [subMenu, setSubMenu] = useState<ContextMenuItem[]>([]);
    const [contextMenuEvent, setContextMenuEvent] = useState(null);
    const [isAutofillCountLoading, setIsAutofillCountLoading] = useState(false);

    const clickedRoofAutofillModuleCountPortrait = useViewerStore((state) => state.clickedRoofAutofillModuleCountPortrait);
    const clickedRoofAutofillModuleCountLandscape = useViewerStore((state) => state.clickedRoofAutofillModuleCountLandscape);
    const clickedRoofAutofillModuleCountBoth = useViewerStore((state) => state.clickedRoofAutofillModuleCountBoth);

    const commonContextMenuOptions: ContextMenuItem[] = [];

    const contextMenuTemplate: ContextMenuTemplate = {
        roof: [],
        obstruction: [],
        tree: [],
        modules: [],
        obstructionObjectContextMenu: [],
        roofObjectContextMenu: [],
        treeObjectContextMenu: [],
        moduleObjectContextMenu: [],
        pathwayObjectContextMenu: [],
        epcTouchContextMenu: [],
        epcContextMenu: []
    };

    const [contextMenuItems, setContextMenuItems] = useState(contextMenuTemplate['roof']);


    const checkCapabilities = async () => {

        contextMenuTemplate.treeObjectContextMenu = [
            {
                title: 'Ghost Tree',
                key: 'deleteSelectedTree',
                icon: <RiDeleteBinLine/>,
                visible: hasCapability('Toggle Ghost Tree')
            },
            {
                title: 'Un-Ghost Tree',
                key: 'deleteSelectedTree',
                icon: <RiDeleteBin2Line/>,
                visible: hasCapability('Toggle Ghost Tree')
            },
            {
                title: 'Clone Tree',
                key: 'cloneSelectedTree',
                icon: <MdContentCopy/>,
                visible: hasCapability('Edit_Tree')
            },
            {title: 'Move Tree', key: 'moveSelectedTree', icon: <BiMove/>, visible: hasCapability('Edit_Tree_Move')},
            {
                title: 'Show AI Options',
                key: 'showTreeCuttingAiOptions',
                icon: <SparkleIcon weight="duotone" />,
                visible: true,
            },
        ];

        contextMenuTemplate.epcTouchContextMenu = [
            {
                title: 'Ghost Tree',
                key: 'deleteSelectedTree',
                icon: <RiDeleteBinLine/>,
                visible: hasCapability('Toggle Ghost Tree')
            },
            {
                title: 'Un-Ghost Tree',
                key: 'deleteSelectedTree',
                icon: <RiDeleteBin2Line/>,
                visible: hasCapability('Toggle Ghost Tree')
            },
            {
                title: 'Ghost Tree And Add to Cart',
                key: 'ghostAddCartSelectedTree',
                icon: <RiDeleteBinLine/>,
                visible: hasCapability('Toggle Ghost Tree')
            },
            {
                title: 'Add to Cart',
                key: 'addCartSelectedTree',
                icon: <RiDeleteBinLine/>,
                visible: false
            },
            {
                title: 'Remove from the cart',
                key: 'removeGhostedTreeFromTheCart',
                icon: <RiDeleteBinLine/>,
                visible: hasCapability('Toggle Ghost Tree')
            },
            {
                title: 'Cancel Action',
                key: 'cancelAction',
                icon: <MdOutlineClose/>,
                visible: hasCapability('Toggle Ghost Tree')
            },

        ];

        contextMenuTemplate.epcContextMenu = [
            {
                title: 'Ghost Tree And Add to Cart',
                key: 'ghostAddCartSelectedTree',
                icon: <RiDeleteBinLine/>,
                visible: hasCapability('Toggle Ghost Tree')
            },
            {
                title: 'Add to Cart',
                key: 'addCartSelectedTree',
                icon: <RiDeleteBinLine/>,
                visible: false
            },
            {
                title: 'Remove from the cart',
                key: 'removeGhostedTreeFromTheCart',
                icon: <RiDeleteBinLine/>,
                visible: hasCapability('Toggle Ghost Tree')
            },
            {
                title: 'Clone Tree',
                key: 'cloneSelectedTree',
                icon: <MdContentCopy/>,
                visible: hasCapability('Edit_Tree')
            },
            {title: 'Move Tree', key: 'moveSelectedTree', icon: <BiMove/>, visible: hasCapability('Edit_Tree_Move')},
        ];

        contextMenuTemplate.moduleObjectContextMenu = [
            // {title: 'Select & Edit Module', key: 'editSelectedModule'},
            {
                title: 'Delete Module',
                key: 'deleteSelectedModule',
                icon: <RiDeleteBinLine/>,
                visible: hasCapability('Edit_Module_Remove')
            },
            {
                title: `Add Module`,
                key: 'addModules',
                icon: <MdOutlineViewModule/>,
                submenu: [
                    {title: `Portrait`, key: 'portAdd', icon: <TbBuildingBank/>},
                    {title: `Landscape`, key: 'landAdd', icon: <TbBuildingCommunity/>},
                ],
                visible: hasCapability('Add_Module')
            },
            {
                title: 'Spin Module',
                key: 'spinSelectedModule',
                icon: <AiOutlineRotateLeft/>,
                visible: hasCapability('Edit_Module_Add')
            },
            {
                title: 'Move Module',
                key: 'moveSelectedModule',
                icon: <BiMove/>,
                visible: hasCapability('Edit_Module_Move')
            },
            {
                title: 'Move Module by Measurement',
                key: 'moveSelectedModuleMeasurement',
                icon: <BiMove/>,
                visible: hasCapability('Edit_Module_Move')
            },
            {
                title: 'Box Select Module',
                key: 'boxSelectModule',
                icon: <BiRectangle/>,
                visible: hasCapability('Box_Select_Module')
            },

        ];

        contextMenuTemplate.obstructionObjectContextMenu.push(...[
            {
                title: 'Clone Obstruction',
                key: 'cloneObstruction',
                icon: <MdContentCopy/>,
                visible: hasCapability('Edit_Obstruction_Remove')
            },
            {
                title: 'Move Obstruction',
                key: 'moveSelectedObstruction',
                icon: <BiMove/>,
                visible: hasCapability('Edit_Obstruction_Move')
            },
        ]);

        contextMenuTemplate.roofObjectContextMenu.push(...[
            {
                title: 'Clear Layout',
                key: 'clearLayout',
                icon: <RiDeleteBinLine/>, visible: true
            },
            {
                title: `Autofill Layout`,
                icon: <RiLayout4Line/>,
                submenu: [
                    {title: `Landscape :`, key: 'roofModuleLand'},
                    {title: `Portrait :`, key: 'roofModulePort'},
                    {title: `Both :`, key: 'roofModuleBoth'},
                ], visible: true
            },
            {
                title: `Mark Building`,
                icon: <IoBookmarkSharp/>,
                submenu: [
                    {title: `Primary`, key: 'buildingModuleOn', icon: <TbBuildingBank/>, visible: true},
                    {title: `Accessory`, key: 'buildingModuleOff', icon: <TbBuildingCommunity/>, visible: false},
                ], visible: true
            },
            {
                title: `Add Module`,
                key: 'addModules',
                icon: <MdOutlineViewModule/>,
                submenu: [
                    {title: `Portrait`, key: 'portAdd', icon: <TbBuildingBank/>},
                    {title: `Landscape`, key: 'landAdd', icon: <TbBuildingCommunity/>},
                ], visible: hasCapability('Add_Module')
            }
        ]);


        if (hasCapability('Orbit')) {
            commonContextMenuOptions.push({
                title: 'Orbit ( Shift+O )',
                key: 'orbit',
                icon: (<GiMoonOrbit/>),
                visible: true
            });
        }
        if (hasCapability('Pan')) {
            commonContextMenuOptions.push({
                title: 'Pan ( Shift+P )',
                key: 'pan',
                icon: (<BiMoveHorizontal/>),
                visible: true
            });
        }
        if (hasCapability('Default_Position')) {
            commonContextMenuOptions.push({
                title: 'Default Position ( Shift+H )',
                key: 'defaultPosition',
                icon: <AiOutlineHome/>,
                visible: true
            });
        }
        if (hasCapability('Box_Select_Tree')) {
            commonContextMenuOptions.push({
                title: 'Box Select Tree ( Alt +T )',
                key: 'boxSelectTree',
                icon: <BiRectangle/>,
                visible: true
            });
        }

        if (hasCapability('Add_Obstructions')) {
            commonContextMenuOptions.push({
                title: 'Add Obstruction',
                key: 'addObstruction',
                icon: <MdRoofing/>,
                visible: true
            });
        }
        if (hasCapability('Add_Tree')) {
            commonContextMenuOptions.push({title: 'Add Tree', key: 'addTree', icon: <FaTree/>, visible: true});
        }
        if (hasCapability('Add_Module')) {
            commonContextMenuOptions.push({
                title: 'Add Module',
                key: 'addModule',
                icon: <MdOutlineViewModule/>,
                visible: hasCapability('Add_Module')
            });
        }

        if (hasCapability('Toggle_Ghost_Obstructions')) {
            contextMenuTemplate.obstructionObjectContextMenu.push({
                title: 'Ghost Obstruction',
                key: 'deleteObstruction',
                icon: <RiDeleteBinLine/>,
                visible: true
            });
        }

        if (hasCapability('Toggle_Ghost_Obstructions')) {
            contextMenuTemplate.obstructionObjectContextMenu.push({
                title: 'Un-Ghost Obstruction',
                key: 'deleteObstruction',
                icon: <RiDeleteBin2Line/>,
                visible: true
            });
        }

        if (hasCapability('Toggle_Shingle')) {
            contextMenuTemplate.roofObjectContextMenu.push({
                title: 'Change Roof Style',
                key: 'changeRoofShingle',
                icon: <RiPaintFill/>,
                visible: true
            });
        }

        if (hasCapability('Mark_Questionable_Roof') || hasCapability('Mark Questionable Roof')) {
            contextMenuTemplate.roofObjectContextMenu.push(...[
                {
                    title: 'Set Questionable Roof',
                    key: 'setQuestionable',
                    icon: <AiOutlineQuestionCircle/>,
                    visible: true
                },
                {
                    title: 'Unset Questionable Roof',
                    key: 'unsetQuestionable',
                    icon: <AiOutlineQuestionCircle/>,
                    visible: true
                },
            ]);
        }
        if (hasCapability('Toggle Pathways')) {
            contextMenuTemplate.pathwayObjectContextMenu.push({
                title: 'Toggle Pathway',
                key: 'toggleSelectedPathway',
                icon: <RiDeleteBinLine/>,
                visible: true
            });
        }


        contextMenuTemplate.roofObjectContextMenu.push(...[
            {
                title: 'Mark As Detached Structure',
                key: 'buildingDetachedStructureOn',
                icon: <RiBuildingFill/>,
                visible: true
            },
            {
                title: 'Unmark As Detached Structure',
                key: 'buildingDetachedStructureOff',
                icon: <RiBuildingFill/>,
                visible: true
            },
        ]);


        contextMenuTemplate.roof = [
            ...commonContextMenuOptions,
            {title: 'Show Lat/Long', key: 'showLatLong', icon: <BiLocationPlus/>, visible: true},
        ];
        contextMenuTemplate.obstruction = [
            ...commonContextMenuOptions,
            {
                title: 'Edit Obstruction',
                key: 'editObstruction',
                icon: <AiFillEdit/>,
                visible: hasCapability('Edit_Obstruction_Add')
            },
        ];
        contextMenuTemplate.tree = [
            ...commonContextMenuOptions,

            {title: 'Edit Tree', key: 'editTree', icon: <AiFillEdit/>, visible: hasCapability('Edit_Tree')},
        ];
        contextMenuTemplate.modules = [
            ...commonContextMenuOptions,
        ];
    };

    const handleContextMenu = useCallback(
        (event: any) => {
            const isTapandHold = useViewerStore.getState().isTapandHold;
            if (event.button === 2 || isTapandHold) {
                const canvas = canvasContainerRef.current;
                event.preventDefault();
                setContextMenuEvent(event);
                const menuWidth = 200; // change this to match the actual width of your menu
                const menuHeight = 250; // change this to match the actual height of your menu
                let x = event.pageX;
                let y = event.pageY;

                //adjust position if menu goes beyond canvas
                if (canvas) {
                    if (x + menuWidth > canvas.offsetWidth) {
                        x = canvas.offsetWidth - menuWidth;
                    }
                    if (y + menuHeight > canvas.offsetHeight) {
                        y = canvas.offsetHeight - menuHeight;
                    }
                }


                setAnchorPoint({
                    x: x,
                    y: y - 60
                })
                setTimeout(() => {
                    const objectType = useViewerStore.getState().pointerDownSelectedObjectType
                    if (isTapandHold && objectType !== "tree") {
                        setShowMenu(false);
                        return
                    }
                    setShowMenu(true);
                }, 200)
            } else {
                return
            }
        },
        [setShowMenu, setAnchorPoint]
    );


    const setCustomContextMenuSelectedObstruction = () => {
        const obj = useViewerStore.getState().pointerDownSelectedObject as any;
        const obstId = obj?.meshType === 'tree' ? resolveTreeObstId(obj) : obj?.obstId;
        if (obstId) sceneViewer.obstId = obstId;
        return obstId
    }


    useEffect(() => {
        if (user?.user_Id) {

            checkCapabilities();

            if (isPointerOnObject) {
                if (pointerDownSelectedObjectType === 'obst') {
                    const obstMeshArr = sceneViewer.obstGroup.children.map( (c : THREEJSGroupType )  => c.children[0].children[0].children[0]);
                    let isGhost = false;
                    obstMeshArr.forEach( (obst : ObstructionMesh) => {

                        const pointerDownSelectedObject = useViewerStore.getState().pointerDownSelectedObject;

                        if (pointerDownSelectedObject && obst.obstId === pointerDownSelectedObject.obstId && obst.delStatus) {

                            sceneViewer.viewerAlert({
                                show: true,
                                title: <div className={"center-wrapper-with-gap"}>
                                    <span>Selected Obstruction is Ghosted</span>
                                </div>,
                                message: "",
                                type: "Info",
                                isModal: false
                            });
                            isGhost = true;
                        }
                    })

                    contextMenuTemplate.obstructionObjectContextMenu.forEach((menuItem) => {
                        if (menuItem.title === 'Un-Ghost Obstruction') {
                            menuItem.visible = isGhost;
                        }
                        if (menuItem.title === 'Ghost Obstruction') {
                            menuItem.visible = !isGhost;
                        }
                    });
                    setContextMenuItems(contextMenuTemplate['obstructionObjectContextMenu'])
                } else if (pointerDownSelectedObjectType === 'roof') {


                    const roof = sceneViewer.roofMeshArr.find( (r: RoofMesh )=> r.roofFaceId === pointerDownSelectedObject.roofFaceId);
                    const isZeroTilt = (Number(roof?.userData?.pitchOverride) === 0 ) || isGroundMount(roof)

                    contextMenuTemplate.roofObjectContextMenu.forEach((menuItem) => {
                        if(!menuItem) return;
                        if (menuItem.title === 'Autofill Layout') {
                            if(!menuItem.submenu) return;
                            menuItem.submenu.forEach((subMenuItem) => {
                                if (isZeroTilt && (subMenuItem.key === 'roofModulePort' || subMenuItem.key === 'roofModuleBoth')) {
                                    subMenuItem.isDisabled = true;
                                }
                            });
                        }

                        if (menuItem.title === 'Add Module') {
                            if(!menuItem.submenu) return;
                            menuItem.submenu.forEach((subMenuItem) => {
                                if (isZeroTilt && subMenuItem.key === 'portAdd') {
                                    subMenuItem.isDisabled = true;
                                }
                            });
                        }
                        if (menuItem.title === 'Mark Building') {
                            const buildingName = useViewerStore.getState().pointerDownSelectedObject.userData.buildingName;
                            const isAccessory = accessoryBuildingList.includes(buildingName);
                            menuItem?.submenu?.forEach((subMenuItem) => {
                                if (subMenuItem.key === 'buildingModuleOn') {
                                    subMenuItem.visible = isAccessory; // Only show "Mark as Primary" if it's currently accessory
                                }

                                if (subMenuItem.key === 'buildingModuleOff') {
                                    subMenuItem.visible = !isAccessory; // Only show "Mark as Accessory" if it's currently primary
                                }
                            });
                        }
                    });

                    if (roof && roof.userData) { //Check if user right clicked on roof instead of wall (or elsewhere)
                        const isRoofDeactive = ifRoofDeactivated(roof.userData.roof_tag_id)
                        contextMenuTemplate.roofObjectContextMenu.push({
                            title: isRoofDeactive ? 'Reactivate Roof' : 'Deactivate Roof',
                            key: isRoofDeactive ? 'enableRoof' : 'disableRoof',
                            icon: <CheckCircleIcon/>,
                            visible: true,
                            specialClassName: isRoofDeactive ? "deactive-roof-context-menu-enable-text" : "deactive-roof-context-menu-disable-text"
                        })
                    }

                    setContextMenuItems(contextMenuTemplate['roofObjectContextMenu'])


                } else if (pointerDownSelectedObjectType === 'tree') {
                    const treeObstId = resolveTreeObstId(pointerDownSelectedObject);
                    if (treeObstId) SetupTreeGroup(sceneViewer, treeObstId, true);
                    if (pathname.includes("price-calculation")) {
                        //Toggle Ghosted Tree Cart Items
                        const isTapandHold = useViewerStore.getState().isTapandHold;
                        let treeExist = treeCartItems.find(tree => tree.obstId === pointerDownSelectedObject.obstId);
                        if (isTapandHold) {
                            if (treeExist) {
                                contextMenuTemplate.epcTouchContextMenu.forEach((menuItem) => {
                                    if (menuItem.title === 'Ghost Tree And Add to Cart' || menuItem.title === 'Add to Cart' || menuItem.title === 'Ghost Tree' || menuItem.title === 'Un-Ghost Tree') {
                                        menuItem.visible = false;
                                    }
                                    if (menuItem.title === 'Remove from the cart') {
                                        menuItem.visible = true;
                                    }
                                });
                            } else {

                                const allDelStatusTrue = sceneViewer.selTreeArr.every((group : TreeGroup) => group.delStatus === true);
                                const idSet = new Set(sceneViewer.selTreeArr.map( (obj : TreeGroup) => obj.obstId));
                                const commonObjects = treeCartItems.some(obj => idSet.has(obj.obstId));
                                contextMenuTemplate.epcTouchContextMenu.forEach((menuItem) => {
                                    if (menuItem.title === 'Remove from the cart' || menuItem.title === 'Un-Ghost Tree') {
                                        menuItem.visible = false;
                                    }
                                    if (allDelStatusTrue && menuItem.title === 'Un-Ghost Tree') {
                                        menuItem.visible = true;
                                    }
                                    if (allDelStatusTrue && menuItem.title === 'Ghost Tree') {
                                        menuItem.visible = false;
                                    }
                                    if (commonObjects && (menuItem.title === 'Un-Ghost Tree' || menuItem.title === 'Ghost Tree')) {
                                        menuItem.visible = false;
                                    }
                                    if (menuItem.title === 'Add to Cart') {
                                        menuItem.visible = allDelStatusTrue;
                                    }
                                    if (menuItem.title === 'Ghost Tree And Add to Cart') {
                                        menuItem.visible = !allDelStatusTrue && canGhostTreeSelection(sceneViewer.selTreeArr);
                                    }
                                    if (menuItem.visible && menuItem.title === 'Ghost Tree') {
                                        menuItem.visible = canGhostTreeSelection(sceneViewer.selTreeArr);
                                    }
                                });
                            }
                            setContextMenuItems(contextMenuTemplate['epcTouchContextMenu'])

                        } else {
                            if (treeExist) {
                                contextMenuTemplate.epcContextMenu.forEach((menuItem) => {
                                    if (menuItem.title === 'Ghost Tree And Add to Cart' || menuItem.title === 'Add to Cart') {
                                        menuItem.visible = false;
                                    }
                                    if (menuItem.title === 'Remove from the cart') {
                                        menuItem.visible = true;
                                    }
                                });
                            } else {
                                const allDelStatusTrue = sceneViewer.selTreeArr.every((group : TreeGroup) => group.delStatus === true);
                                contextMenuTemplate.epcContextMenu.forEach((menuItem) => {
                                    if (menuItem.title === 'Remove from the cart') {
                                        menuItem.visible = false;
                                    }
                                    if (menuItem.title === 'Add to Cart') {
                                        menuItem.visible = allDelStatusTrue;
                                    }
                                    if (menuItem.title === 'Ghost Tree And Add to Cart') {
                                        menuItem.visible = !allDelStatusTrue && canGhostTreeSelection(sceneViewer.selTreeArr);
                                    }
                                });
                            }

                            setContextMenuItems(contextMenuTemplate['epcContextMenu'])
                        }
                    } else {
                        const allDelStatusTrue = sceneViewer?.selTreeArr.every( (group : TreeGroup) => group.delStatus === true);
                        if (allDelStatusTrue) {
                            contextMenuTemplate.treeObjectContextMenu.forEach((menuItem) => {
                                if (menuItem.title === 'Ghost Tree') {
                                    menuItem.visible = false;
                                }
                                if (menuItem.title === 'Un-Ghost Tree') {
                                    menuItem.visible = true;
                                }
                            });
                        } else {
                            contextMenuTemplate.treeObjectContextMenu.forEach((menuItem) => {
                                if (menuItem.title === 'Ghost Tree') {
                                    menuItem.visible = canGhostTreeSelection(sceneViewer.selTreeArr);
                                }
                                if (menuItem.title === 'Un-Ghost Tree') {
                                    menuItem.visible = false;
                                }
                            });
                        }
                        setContextMenuItems(contextMenuTemplate['treeObjectContextMenu'])
                    }
                } else if (pointerDownSelectedObjectType === 'module') {
                    http://localhost:4200/configure?sfid=006Pl00000UnDCrIAN)
                    setContextMenuItems(contextMenuTemplate['moduleObjectContextMenu'])
                } else if (pointerDownSelectedObjectType === 'pathway') {
                    setContextMenuItems(contextMenuTemplate['pathwayObjectContextMenu'])
                } else if (pointerDownSelectedObjectType === null) {
                    setShowMenu(false)
                    useViewerStore.setState({isPointerOnObject: false})
                }
            } else {
                if (pathname.includes("roof")) {

                    setContextMenuItems(contextMenuTemplate['roof'])
                } else if (pathname.includes("obstruction")) {
                    setContextMenuItems(contextMenuTemplate['obstruction'])
                } else if (pathname.includes("tree")) {
                    setContextMenuItems(contextMenuTemplate['tree'])
                } else if (pathname.includes("modules")) {
                    setContextMenuItems(contextMenuTemplate['modules'])
                }
            }
        }


    }, [isPointerOnObject, pointerDownSelectedObjectType, pointerDownSelectedObject, pathname, user, sceneViewer,refreshContextMenu, accessoryBuildingList]);

    const maybeLoadAutofillCountsOnDemand = async (menuItem?: ContextMenuItem) => {
        if (!menuItem) return;
        if (menuItem.title !== 'Autofill Layout') return;
        if (isAutofillCountLoading) return;

        const selectedRoofFaceId = sceneViewer?.preSelRoofId;
        const roofMesh = sceneViewer?.roofMeshArr?.find((r: RoofMesh) => r?.roofFaceId === selectedRoofFaceId);
        if (!roofMesh) return;

        // Always recompute on hover so counts stay in sync with the 33% rule
        // (setbacks / placed modules / enforce-override can change after a prior cache).
        setIsAutofillCountLoading(true);
        // Let submenu paint with loading text before synchronous count computation starts.
        await new Promise((resolve) => setTimeout(resolve, 0));

        try {
            // Drop stale cache so updateModuleCount writes fresh 33%-aware values.
            if (roofMesh.userData) {
                roofMesh.userData.moduleCount = {};
            }

            updateModuleCount(sceneViewer, 'port', false, selectedRoofFaceId);
            updateModuleCount(sceneViewer, 'land', false, selectedRoofFaceId);
            updateModuleCount(sceneViewer, 'both', false, selectedRoofFaceId);

            const latestRoof = sceneViewer?.roofMeshArr?.find((r: RoofMesh) => r?.roofFaceId === selectedRoofFaceId);
            if (!latestRoof) return;

            const latestCounts = latestRoof.userData?.moduleCount || {};
            // Ensure all three keys exist even if updateModuleCount skipped this roof
            // (disabled / too steep / ineligible).
            latestRoof.userData.moduleCount = {
                port: typeof latestCounts.port === 'number' ? latestCounts.port : 0,
                land: typeof latestCounts.land === 'number' ? latestCounts.land : 0,
                both: typeof latestCounts.both === 'number' ? latestCounts.both : 0,
            };
            useViewerStore.setState({
                clickedRoofAutofillModuleCountPortrait: latestRoof.userData.moduleCount.port,
                clickedRoofAutofillModuleCountLandscape: latestRoof.userData.moduleCount.land,
                clickedRoofAutofillModuleCountBoth: latestRoof.userData.moduleCount.both,
            });
        } finally {
            setIsAutofillCountLoading(false);
        }
    };

    const showSubmenu = (event : any, index : number) => {
        let menus = contextMenuItems;

        menus.map((item, index_item) => {

            item['is_active'] = index === index_item;

            return item;
        })

        setSubMenu([...menus]);
        maybeLoadAutofillCountsOnDemand(menus[index]).catch(() => {
            setIsAutofillCountLoading(false);
        });
    }

    const hideSubmenu = (event : any, index : number) => {
        let menus = contextMenuItems;

        menus.map((item, index_item) => {
            item['is_active'] = false;

            return item;
        })

        setSubMenu([...menus]);
    }


    const handleClick = useCallback(() => {
        if (showMenu) {
            setShowMenu(false)
            useViewerStore.setState({isPointerOnObject: false})
        }

    }, [showMenu, isPointerOnObject]);

    useEffect(() => {
        const rendererCanvas = canvasContainerRef.current;

        rendererCanvas?.addEventListener('contextmenu', (e) => {
            e.preventDefault()
        })

        rendererCanvas?.addEventListener('closeContextMenu', (e) => {
            setShowMenu(false)
        })

        rendererCanvas?.addEventListener("click", handleClick, true);
        rendererCanvas?.addEventListener("pointerup", handleContextMenu);

        return () => {
            rendererCanvas!.removeEventListener("click", handleClick);
            // rendererCanvas.removeEventListener("pointerup", handleContextMenu);
        };
    }, [handleClick, handleContextMenu]);

    const setRequiredPathnameAndClickFunctionalityButton = (requiredPathname: string, functionBtnRefName: string, preClickCallbackFunc?: () => void ) => {

        if (!pathname.includes(requiredPathname)) {

            setPathname("/configure/" + requiredPathname)

            setTimeout(() => {
                if(preClickCallbackFunc) preClickCallbackFunc()
                useViewerStore.getState().refs[functionBtnRefName]?.click()
            }, 100)
        } else {
            if(preClickCallbackFunc) preClickCallbackFunc()
            useViewerStore.getState().refs[functionBtnRefName]?.click();
        }
    }



    const handleContextMenuClick = (e : any) => {
        const isTapandHold = useViewerStore.getState().isTapandHold;
        switch (e.target.getAttribute('data-key')) {
            case 'orbit':
                sceneViewer.setOrbitControlsMode('orbit');
                if (sceneViewer.helper !== null) {
                    sceneViewer.removeSelectionBoxHelper()
                }
                break
            case 'pan':
                sceneViewer.setOrbitControlsMode('pan');
                break
            case 'boxSelectTree':
                sceneViewer.setupSelectionBoxHelper('tree')
                break
            case 'boxSelectModule':
                sceneViewer.selectType = 'module'
                sceneViewer.setupSelectionBoxHelper('module')
                break
            case 'showLatLong':
                sceneViewer.alertSelectedLatLongPoints(contextMenuEvent);
                break
            case 'addObstruction':
                setRequiredPathnameAndClickFunctionalityButton('obstruction', "addObstBtn");
                break
            case 'addTree':
                setRequiredPathnameAndClickFunctionalityButton('tree', "btnTreeAdd");
                break
            case 'defaultPosition':
                clickButtonWithRef("defaultPositionBtn")
                break
            case 'moveObstruction':
                sceneViewer.viewerAlert({
                    show: true,
                    title: "Move Obstruction",
                    message: "Click on Obstruction or set of Obstructions to Move",
                    type: "Info",
                    isModal: true
                })
                setRequiredPathnameAndClickFunctionalityButton('obstruction', "moveObstBtn");
                break
            case 'addModule':
                setRequiredPathnameAndClickFunctionalityButton('modules', "addModuleBtn");
                break
            case 'deleteObstruction':
                setCustomContextMenuSelectedObstruction()
                sceneViewer.addStep(EditAction.GhostObstruction, selectedObstruction.obstId, "", selectedObstruction.obstId);
                sceneViewer.setObstDelete();
                break
            case 'moveSelectedObstruction':
                setRequiredPathnameAndClickFunctionalityButton('obstruction', "moveObstBtn", () => {
                    let obstID = setCustomContextMenuSelectedObstruction()
                    SetupObstUI(sceneViewer, obstID)
                });
                break
            case 'moveSelectedTree':
                setRequiredPathnameAndClickFunctionalityButton('tree', "moveTreeModeBtn", () => {
                    let obstID = setCustomContextMenuSelectedObstruction()
                    if (obstID) SetupTreeGroup(sceneViewer, obstID, true);
                    useViewerStore.setState({isMoveTreeActive: true});
                    sceneViewer.setMoveMode(true);

                });
                break
            case 'showTreeCuttingAiOptions': {
                const currentId = useViewerStore.getState().treeCuttingAiOptionsRequestId || 0;
                useViewerStore.setState({
                    treeCuttingAiOptionsRequestId: currentId + 1,
                    treeCuttingScenariosModalOpen: true,
                });
                break
            }
            case 'cloneObstruction':
                if (!pathname.includes("obstruction")) {
                    setPathname('/configure/obstruction')
                    setTimeout(() => {
                        let obstID = setCustomContextMenuSelectedObstruction()
                        SetupObstUI(sceneViewer, obstID)
                        sceneViewer.setPushMode(true, true);
                        useViewerStore.setState({isAddObstructionActive: true});
                    }, 100)
                } else {
                    let obstID = setCustomContextMenuSelectedObstruction()
                    SetupObstUI(sceneViewer, obstID)
                    sceneViewer.setPushMode(true, true);
                    useViewerStore.setState({isAddObstructionActive: true});
                }
                break
            case 'cloneSelectedTree':
                if (!pathname.includes("tree")) {
                    setPathname('/configure/tree')
                    setTimeout(() => {
                        let obstID = setCustomContextMenuSelectedObstruction()
                        if (obstID) SetupTreeGroup(sceneViewer, obstID, true)
                        sceneViewer.setPushMode(true, true);
                        useViewerStore.setState({isAddTreeActive: true});
                    }, 100)
                } else {
                    let obstID = setCustomContextMenuSelectedObstruction()
                    if (obstID) SetupTreeGroup(sceneViewer, obstID, true)
                    sceneViewer.setPushMode(true, true);
                    useViewerStore.setState({isAddTreeActive: true});
                }
                break
            case 'deleteSelectedTree':
                const olderValueArr = sceneViewer.selTreeArr;
                sceneViewer.setTreeProperty(TreeProperty.delete);
                sceneViewer.addStep(EditAction.GhostTree, '', olderValueArr, sceneViewer.selTreeArr);
                if (isTapandHold) {
                    useViewerStore.setState({isTapandHold: false});
                    useViewerStore.setState({isTabandHoldUp: false});
                }
                sceneViewer.deselectAllSelectedObjectsAndEndTask();
                break
            case 'ghostAddCartSelectedTree':
            case 'addCartSelectedTree':
                sceneViewer.addToCart();
                break
            case 'removeGhostedTreeFromTheCart':
                sceneViewer.removeTreeFromCart();
                if (isTapandHold) {
                    useViewerStore.setState({isTapandHold: false});
                    useViewerStore.setState({isTabandHoldUp: false});
                }
                sceneViewer.deselectAllSelectedObjectsAndEndTask();
                break
            case 'deleteSelectedModule':
                sceneViewer.setModuleSetting('delete');
                break
            case 'spinSelectedModule':
                const selModules = GetSelModules(sceneViewer.moduleMeshArr)
                selModules.forEach((module: ModuleMesh) => {
                    const currentDir = module.dir;

                    if (currentDir === "port" || currentDir === "both") {
                        sceneViewer.setModuleSetting('dir', 'land');
                    } else {
                        sceneViewer.setModuleSetting('dir', 'port');
                    }
                })



                break
            case 'moveSelectedModule':
                setRequiredPathnameAndClickFunctionalityButton('modules', "moveModuleBtn")
                break
            case "changeRoofShingle":
                setRequiredPathnameAndClickFunctionalityButton('roof', "roofShingleTabIcon")
                break
            case "clearLayout":
                const roof = sceneViewer.roofMeshArr.find( (r : RoofMesh) => r.roofFaceId === sceneViewer.preSelRoofId);
                if (roof) {
                    setPathname('/configure/modules')
                    sceneViewer.setClearFaceModule(roof);
                    sceneViewer.deselectAllSelectedObjectsAndEndTask();
                }
                break
            case "toggleSelectedPathway":
                const selPathway = useViewerStore.getState().pointerDownSelectedObject;
                sceneViewer.addStep(EditAction.TogglePathway, selPathway.pathwayId);
                sceneViewer.togglePathway()
                break
            case "moveSelectedModuleMeasurement":
                sceneViewer.viewerAlert({
                    show: true,
                    title: "Move Module by Measurement",
                    message: <MoveModuleByMeasurement/>,
                    messageType: "info",
                    isModal: true
                })
                break
            case "roofModuleLand":
                sceneViewer.setRoofModuleDir('land');
                break
            case "roofModulePort":
                sceneViewer.setRoofModuleDir('port');
                break
            case "roofModuleBoth":
                sceneViewer.setRoofModuleDir('both');
                break
            case "buildingModuleOn":
                sceneViewer.setBuildingModule(false);
                break
            case "buildingModuleOff":
                sceneViewer.setBuildingModule(true);
                break
            case "buildingDetachedStructureOn":
                setBuildingAsDetachedStructure(true);
                break
            case "buildingDetachedStructureOff":
                setBuildingAsDetachedStructure(false);
                break
            case "setQuestionable":
                sceneViewer.setQuestionable(pointerDownSelectedObject);
                break
            case "unsetQuestionable":
                sceneViewer.unsetQuestionable(pointerDownSelectedObject);
                break
            case "portAdd":
                setRequiredPathnameAndClickFunctionalityButton('modules', "addModuleBtn",() => {
                    sceneViewer.moduleDir = 'port';
                    sceneViewer.setModuleSetting('dir', 'port');
                    useViewerStore.setState({isAddModuleActive: false});
                })
                break
            case "landAdd":
                setRequiredPathnameAndClickFunctionalityButton('modules', "addModuleBtn" ,() => {
                    sceneViewer.moduleDir = 'land';
                    useViewerStore.setState({isAddModuleActive: false});
                    sceneViewer.setModuleSetting('dir', 'land');
                })
                break
            case "cancelAction":
                useViewerStore.setState({isTapandHold: false});
                useViewerStore.setState({isTabandHoldUp: false});
                sceneViewer.deselectAllSelectedObjectsAndEndTask();
                break
            case "enableRoof":
                const roofToEnable = sceneViewer.roofMeshArr.find( (r : RoofMesh )=> r.roofFaceId === sceneViewer.preSelRoofId)
                reActivateRoof(roofToEnable)
                break
            case "disableRoof":
                const roofToDisable = sceneViewer.roofMeshArr.find( (r : RoofMesh ) => r.roofFaceId === sceneViewer.preSelRoofId)
                deActivateRoof(roofToDisable)
                break
            default:
                break


        }
        setShowMenu(false);
    }
    useEffect(() => {
        if (showMenu) {
            setShowMenu(false)
        }
    }, [pathname])


    return (
        <>
            {showMenu ? (
                <div
                    ref={(el) => {
                        if (el && !el.getAttribute('data-context-menu-ref')) {
                            el.setAttribute('data-context-menu-ref', 'true');
                            const handleOutsideClick = (e: MouseEvent) => {
                                if (el && !el.contains(e.target as Node)) {
                                    const isTapandHold = useViewerStore.getState().isTapandHold;
                                    if (e.button !== 2 && !isTapandHold) {
                                        setShowMenu(false);
                                        sceneViewer.deselectAllSelectedObjectsAndEndTask()
                                    }
                                }
                            };
                            document.addEventListener('mousedown', handleOutsideClick);
                            return () => document.removeEventListener('mousedown', handleOutsideClick);
                        }
                    }}
                    onContextMenu={(e) => e.preventDefault()}
                    id="context-menu"
                    className="context"
                    style={{ top: anchorPoint.y, left: anchorPoint.x}}
                >
                        {contextMenuItems.map((item, index) => {
                            return (
                                item.submenu && item.submenu.length > 0 ? (
                                    item.visible &&
                                    <li
                                        className="context__item sub-menu"
                                        key={index}
                                    >
                                        <button
                                            data-key={item.key}
                                            // onClick={handleContextMenuClick}
                                            className="context__toggle "
                                            onMouseEnter={(event) => showSubmenu(event, index)}
                                            onMouseLeave={(event) => hideSubmenu(event, index)}
                                            aria-haspopup="menu"
                                            aria-expanded={subMenu ? "true" : "false"}
                                        >
                                            {item.icon && <i data-key={item.key} className='context__icon'>{item.icon}</i>}
                                            {item.title}
                                            <AiFillCaretRight/>
                                            {(item['is_active']) && (
                                                <div className="context__submenu--wrapper">
                                                    <ul className="context__submenu">
                                                        {item.submenu.map((subitem, index) => {
                                                            return (
                                                                subitem.visible !== false && !subitem.isDisabled &&
                                                                <li
                                                                    className="context__item"
                                                                    key={index}
                                                                    data-key={subitem.key}
                                                                    onClick={isAutofillCountLoading ? undefined : handleContextMenuClick}
                                                                >
                                                                    {
                                                                        subitem.icon &&
                                                                        <i data-key={subitem.key}
                                                                           className='context__icon'>{subitem.icon}</i>

                                                                    }
                                                                    {subitem.title}
                                                                    {subitem.title === "Landscape :" && <> {isAutofillCountLoading ? 'Calculating...' : clickedRoofAutofillModuleCountLandscape} </>}
                                                                    {subitem.title === "Portrait :" && <> {isAutofillCountLoading ? 'Calculating...' : clickedRoofAutofillModuleCountPortrait} </>}
                                                                    {subitem.title === "Both :" && <> {isAutofillCountLoading ? 'Calculating...' : clickedRoofAutofillModuleCountBoth} </>}
                                                                </li>
                                                            )
                                                        })}
                                                    </ul>
                                                </div>
                                            )}
                                        </button>
                                    </li>
                                ) : (
                                    item.visible &&
                                    <li className={`context__item ${item?.specialClassName || ""}`}
                                        data-key={item.key}
                                        key={index}
                                        onClick={handleContextMenuClick}>
                                        {item.icon &&
                                            <i data-key={item.key} key={index} className='context__icon'>{item.icon}</i>}
                                        {item.title}
                                    </li>
                                )
                            )
                        })}
                </div>
            ) : (
                <></>
            )}
        </>
    );
};

export default ContextMenu;